<template>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

        <!-- GENERAL -->
        <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Algemeen' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                <template v-if="user !== null">
                    <vx-card no-shadow>

                        <!-- Info -->
                        <vs-input class="w-full" label-placeholder="Email" v-model="user.email"></vs-input>
                        <vs-input class="w-full" label-placeholder="Telefoonnummer" v-model="user.phone_number"></vs-input>
                        <vs-input class="w-full" label-placeholder="Kleur" v-model="user.color"></vs-input>

                        <!-- Save & Reset Button -->
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button class="ml-auto mt-2" @click="update">Opslaan</vs-button>
                        </div>
                    </vx-card>
                </template>
            </div>
        </vs-tab>
    </vs-tabs>
</template>
<script>
    export default {
        data() {
            return {
                user: null
            };
        },

        methods: {
            getStaff() {
                this.$http.get('/v1/self-user', {
                    headers: {
                        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
                    }
                }).then((response) => {
                    this.user = response.data;
                }).catch((error) => {
                    this.$util.logError(error, this.$vs);
                });
            },
            update() {
                let data = {
                    email: this.user.email,
                    phone_number: this.user.phone_number,
                    color: this.user.color
                };
                console.log(data);
                this.$http.post('/v1/staff/settings/update', data, {
                    headers: {
                        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
                    }
                }).then(() => {
                    this.$util.notify('Gegevens opgeslagen', 'Je gegevens zijn opgeslagen!', this.$vs);
                    localStorage.setItem('color', JSON.stringify(this.user.color))
                }).catch((error) => {
                    this.$util.logError(error, this.$vs);
                });
            }
        },

        computed: {
            isSmallerScreen () {
                return this.$store.state.windowWidth < 768
            }
        },

        mounted() {
            this.getStaff();
        }
    };
</script>
